<ng-container *transloco="let t; scope: 'catalog'">
  <button
    class="flex listing-filters-item-button flex--jc-space-between flex--ai-center js-listing-filters-item-button default-font-sizes"
    (click)="toggleAccordion()"
  >
    <span>{{ facet.key }}</span>

    <div class="listing-filters-item-mobile-active default-font-sizes default-font-sizes--ultra-small"></div>

    <div class="listing-filters-item-button-plus">
      <div></div>
      <div></div>
    </div>
  </button>

  <div class="listing-filters-item-options-outer">
    <div class="listing-filters-item-options" [ngClass]="open ? 'open' : ''">
      <div class="listing-filters-title">
        <button class="listing-filters-close js-filters-close" [ngClass]="open ? 'open' : ''" (click)="toggleAccordion()">
          <i class="icon-close"></i>
        </button>

        <div class="flex listing-filters-title-filters flex--jc-space-between">
          <div class="flex flex--ai-center">
            <div class="default-font-sizes default-font-sizes--medium">
              {{ t("catalog.facet-item.filter-selection") }}
            </div>

            <span class="listing-filters-title-count default-font-sizes default-font-sizes--medium">3</span>
          </div>

          <button (click)="clearAllFilters()" class="btn-slim listing-active-filters-reset">
            {{ t("catalog.facet-item.reset-filters") }}
          </button>
        </div>
      </div>

      <div class="listing-filters-item-reset">
        <button (click)="clearAllFilters()" class="default-font-sizes default-font-sizes--small">
          {{ t("catalog.facet-item.reset") }}
        </button>
        <!--        <button class="default-font-sizes default-font-sizes&#45;&#45;small">-->
        <!--          {{ t("catalog.facet-item.search") }}-->
        <!--        </button>-->
      </div>

      <div class="listing-filters-item-search default-font-sizes default-font-sizes--small">
        <input type="text" placeholder="{{ t('catalog.facet-item.search-placeholder') }}" [formControl]="searchInput" />

        <button (click)="resetSearchInput()">
          <i class="icon-close"></i>
        </button>
      </div>

      <div class="listing-filters-item-options-inner">
        <div
          class="listing-filters-item-option default-font-sizes default-font-sizes--very-small"
          *ngFor="let option of facet.values | facetOptionFilter : (filterValue$ | async); let i = index; trackBy: trackByFn"
        >
          <app-facet-option [option]="option" [facetName]="facet.key" (facetChanged)="facetChanged.emit($event)"> </app-facet-option>
        </div>
      </div>
    </div>
  </div>
</ng-container>
